export function header() {
  const homeHero = document.querySelector('#home-hero');
  if(homeHero) {
    let bodyHeight = '';

    const setOffset = () => {
      bodyHeight = homeHero.clientHeight;
    }

    const scroller = () => {
      const scTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
      if(bodyHeight <= scTop) {
        document.body.classList.add('home-headerlogo-show');
      } else {
        document.body.classList.remove('home-headerlogo-show');
      }
    }

    window.addEventListener('resize', () => {
      setOffset();
      scroller();
    });

    window.addEventListener('scroll', scroller);

    setOffset();
    scroller();
  }

}